module.exports = __webpack_public_path__ + "static/media/banner-three.fd303757.png";